<script setup lang="ts">
import { useBlogTagsStore } from "@/stores/blogTagsStore";
import { useLangStore } from "@/stores/langStore";
import { defineEmits, onMounted } from "vue";
import { useBlogsStore } from "@/stores/blogsStore";
import { useSelectBlogTag } from "@/utils/useSelectBlogTag";

const tagsStore = useBlogTagsStore();
const blogStore = useBlogsStore();
const langStore = useLangStore();
const { selectTag } = useSelectBlogTag();

const emits = defineEmits(["closeMenu"]);

onMounted(() => {
  tagsStore.loadBlogTags();
});

function handleSelectTag(tagId: number) {
  selectTag(tagId);
  emits("closeMenu");
}
</script>

<template>
  <div class="flex-1 overflow-y-auto mt-3 mb-3">
    <div class="flex flex-col gap-3">
      <div
        v-for="tag in tagsStore.blogTags"
        :key="tag.id"
        class="group flex justify-between items-center px-4 py-2 border rounded-lg text-left"
        :class="[
          tagsStore.selectedBlogTagId === tag.id
            ? 'bg-brown text-white pointer-events-none'
            : 'text-brown bg-white hover:bg-hover hover:cursor-pointer',
          blogStore.isListLoading ? 'pointer-events-none opacity-50' : '',
        ]"
        @click="handleSelectTag(tag.id)"
      >
        <span
          class="sf-pro-sm"
          :class="
            tagsStore.selectedBlogTagId === tag.id
              ? 'text-white'
              : 'group-hover:text-active'
          "
        >
          {{
            tag.translations[langStore.current] ||
            tag.translations[langStore.fallbackLang]
          }}
        </span>

        <span
          class="tag-counter"
          :class="
            tagsStore.selectedBlogTagId === tag.id
              ? 'bg-white text-black'
              : 'bg-muted group-hover:bg-active text-white'
          "
        >
          {{ tag.blogsCount }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.text-counter {
  font-family: SF Pro Text, serif;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: right;
  vertical-align: middle;
}

.tag-counter {
  @apply min-w-[25px] h-[25px] px-2 flex items-center justify-center rounded-full text-counter;
}
</style>
